import { cva } from 'class-variance-authority'

import type { ButtonSize } from '@/types/component'

export const BUTTON_SIZE_CLASSES: Partial<Record<ButtonSize, string>> = {
  mini: 'btn-xs',
  small: 'btn-sm',
  medium: 'btn-md',
  large: 'btn-lg',
}

export const BUTTON_SVG_SIZE_CLASSES: Partial<Record<ButtonSize | 'default', string>> = {
  mini: 'size-4',
  small: 'size-5',
  default: 'size-6',
}

const BASE_BUTTON_CLASSES =
  'relative border-0 rounded transition-colors cursor-pointer disabled:cursor-default flex justify-center items-center flex-nowrap'

export const buttonVariants = cva(BASE_BUTTON_CLASSES, {
  variants: {
    type: {
      primary: 'text-white bg-yellow-50 hover:bg-yellow-60 active:bg-yellow-80 disabled:(bg-gray-20 text-gray-60)',
      secondary:
        'text-black-50 bg-white border-1 border-gray-50 active:(text-yellow-50 border-yellow-50) disabled:(text-gray-60 border-gray-60) [&.active]:(text-yellow-50 border-yellow-50)',
      tertiary: 'text-black-50 bg-gray-20 border-gray-50 disabled:(text-gray-60 border-gray-60)',
      default: '',
      ghost: 'text-black-50 bg-transparent hover:bg-gray-20 active:bg-gray-40 disabled:(text-gray-60 bg-transparent)',
      text: 'text-black-50 bg-transparent hover:bg-gray-20 active:bg-gray-40 disabled:(text-gray-60 bg-transparent) [&.active]:text-yellow-50',
      'primary-text': 'text-yellow-50 bg-transparent disabled:(text-gray-60 bg-transparent)',
      icon: 'bg-transparent hover:bg-gray-20 active:bg-gray-40 disabled:(text-gray-60 bg-transparent)',
      seeker: 'text-white bg-yellow-50 disabled:bg-gray-20',
      pro: 'text-white bg-pink-50 disabled:bg-pink-20',
      elite: 'text-white bg-blue-50 disabled:bg-blue-20',
    },
    size: {
      mini: 'px-3 py-0.5 text-sm gap-1',
      small: 'px-3 py-1 text-base gap-1',
      medium: 'px-4 py-2 text-lg gap-2',
      large: 'px-4 py-2 text-lg gap-2',
    },
  },
  compoundVariants: [
    { type: 'icon', size: 'mini', class: 'size-6 p-1' },
    { type: 'icon', size: 'small', class: 'size-8 p-1.5' },
    { type: 'icon', size: 'medium', class: 'size-10 p-2' },
    { type: 'icon', size: 'large', class: 'size-10 p-2' },
  ],
})
